<template>
    <div class="lx-wrapper">
        <input v-if="data == 'yes'" type="radio" name="select" id="option-1" checked>
        <input v-else type="radio" name="select" id="option-1">
        <input v-if="data == 'no'" type="radio" name="select" id="option-2" checked>
        <input v-else type="radio" name="select" id="option-2">
        <label for="option-1" class="option option-1" @click="select('yes')">
            <span>Ja</span>
            <div class="dot"></div>
            </label>
        <label for="option-2" class="option option-2" @click="select('no')">
            <span>Nein</span>
            <div class="dot"></div>
        </label>
    </div>
  </template>
  
  <script>
  export default {
    props: {
        data: String
    },
    data() {
      return {
      }
    },
    computed: {
        // a computed getter
    },
    methods: {
        select(value) {
            this.$emit('selectRadio', value)
        }
    },
    mounted() {
    },
    watch: {
    }
  };
</script>
  
<style>
    .lx-wrapper{
        display: flex;
        background: #fff;
        height: 40px;
        width: 100%;
        gap: 38px;
        align-items: center;
        justify-content: space-evenly;
    }
    .lx-wrapper .option{
        background: #fff;
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        border-radius: 6px;
        cursor: pointer;
        padding: 0 12px;
        border: 1.5px solid #E3E3E3;
        transition: all 0.3s ease;
    }
    .lx-wrapper .option .dot{
        height: 14px;
        width: 14px;
        background: #EEEEEE;
        border-radius: 50%;
        box-shadow: inset 0px 0px 1px rgba(0, 0, 0, 0.1);
        position: relative;
    }
    .lx-wrapper .option .dot::before{
        position: absolute;
        content: "";
        top: 3.4px;
        left: 3.4px;
        width: 7px;
        height: 7px;
        background: black;
        border-radius: 50%;
        opacity: 0;
        transform: scale(1.5);
        transition: all 0.3s ease;
    }
    input[type="radio"]{
        display: none;
    }
    #option-1:checked:checked ~ .option-1,
    #option-2:checked:checked ~ .option-2{
        border-color: black;
    }
    #option-1:checked:checked ~ .option-1 .dot,
    #option-2:checked:checked ~ .option-2 .dot{
        background: #EEEEEE;
    }
    #option-1:checked:checked ~ .option-1 .dot::before,
    #option-2:checked:checked ~ .option-2 .dot::before{
        opacity: 1;
        transform: scale(1);
    }
    .wrapper .option span{
        font-weight: 500;
        font-size: 14px;
        line-height: 21px;
        color: #000000;
    }
    #option-1:checked:checked ~ .option-1 span,
    #option-2:checked:checked ~ .option-2 span{
        font-weight: 500;
        font-size: 14px;
        line-height: 21px;
        color: #000000;
    }
</style>